import mixins from '@streamster/shared/app/styles';
import { StyleSheet } from 'react-native';

export const tableStyles = StyleSheet.create({
  transactionRow: {
    flexDirection: 'row',
    color: mixins().color.white,
    paddingHorizontal: 15,
    paddingVertical: 3,
    borderBottomColor: mixins().color.grayDark,
    borderBottomWidth: 1,
    borderStyle: 'solid',
    gap: 10,
    alignItems: 'center',
  },
  transactionHeadingRow: {
    backgroundColor: mixins().color.dark,
    paddingVertical: 8,
    borderBottomWidth: 0,
    marginBottom: 5,
  },
  columnCode: { flexBasis: 300, flexGrow: 1, color: mixins().color.white },
  columnDiscountType: { flexBasis: 140, flexShrink: 1, color: mixins().color.white },
  columnDiscountValue: { flexBasis: 140, flexShrink: 1, color: mixins().color.white },
  columnTransactionType: { flexBasis: 150, color: mixins().color.white },
  columnUsagesLeft: { flexBasis: 80, textAlign: 'right', color: mixins().color.white },
});
